// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"87":"47bb64a4","259":"1a2eab46","293":"662af482","297":"a8ee3622","413":"ebf77f7e","484":"f4d349ff","587":"24521009","787":"140aa59f","848":"6bd58229","936":"0131871d"}[chunkId] + ".chunk.js";
};